import React from 'react';

import { LinkProps } from '@soluto-design/link';
import { PictureProps } from '@soluto-design/picture';
import cls from '@soluto-design/styles/cls';

import { PersonProps } from '../../atoms/TagAuthor';
import CardBase from '../CardBase';
import { CardBottom, CardTop } from '../CardPieces';

export interface CardContentProps {
    tag?: string;
    title?: string;
    text?: string;
    date?: string;
    persons?: PersonProps[];
    cta?: LinkProps;
    logo?: PictureProps;
    location?: string;
}

export default function CardContent({
    tag,
    title,
    text,
    date,
    persons,
    cta,
    logo,
}: CardContentProps) {
    return (
        <>
            <CardBase
                href={cta?.href}
                className={cls(
                    'flex flex-col min-h-[492px] xl:min-h-[540px] p-lg overflow-hidden rounded-large bg-background-brand-primary hover:bg-background-secondary',
                    cta?.disabled && 'bg-background-disabled',
                )}>
                <CardTop
                    tag={tag}
                    title={title}
                    logo={logo}
                    className="flex flex-col gap-xs pb-xs"
                />
                <CardBottom
                    text={text}
                    date={date}
                    cta={cta}
                    persons={persons}
                    buttonTabIndex={-1}
                    className="flex flex-col grow justify-between"
                />
            </CardBase>
        </>
    );
}
